<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
      <div class="col-md-12">
        <ol class="breadcrumb font-class">
          <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
          <li class="active">关于博远</li>
        </ol>
      </div>
    </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- our work start -->
    <div ref="bottomContent" class="our-work-area" @mousewheel="scrool">
       <div class="row">
         <div class="center_column col-xs-12 col-sm-12">
           <div class="product_list_wrapper columns-3">
             <ul id="product_list" class="product_list product_base_list list">
               <li class="ajax_block_product base_product">
                 <div class="product-container">
                   <div class="right-block">
                     <h3>
                       <a class="product-name" href="/#/aboutCompany"> 公司简介</a>
                     </h3>
                     <!--                       <p class="product_reference">Model: PVP31HLXWH</p>-->
                     <p class="product-desc">{{companyDesc}}</p>
                     <div class="absolute-bottom">
                       <div class="button-container button-list">
                         <a class="btn btn-default" href="/#/aboutCompany"> <span>查看详情</span> </a></div>
                     </div>
                   </div>
                 </div>
               </li>
               <li class="ajax_block_product base_product">
                 <div class="product-container">
                   <div class="right-block">
                     <h3>
                       <a class="product-name" href="/#/aboutCertificate"> 资质及证书 </a>
                     </h3>
                     <p class="product-desc" itemprop="description">{{certificateDesc}}</p>
                     <div class="color-list-container"></div>
                     <div class="absolute-bottom">
                       <div class="button-container button-list">
                         <a class="btn btn-default" href="/#/aboutCertificate" title="View"> <span>查看详情</span> </a>
                       </div>
                     </div>
                   </div>
                 </div>
               </li>
             </ul>
           </div>
         </div>
       </div>
    </div>
    <!-- our work end -->
  </div>
</template>

<script>
export default {
  name: 'commercial',
  data () {
    return {
      currentFirstIndex: 0,
      listHeight: [],
      ExampleTypeData: [],
      shockDesc: '公司新闻简介',
      dataDesc: '典型案例简介',
      certificateDesc: '资质及相关证书简介',
      companyDesc: '公司简介'
    }
  },
  mounted () {
  },
  methods: {
    selectMenu (index, event) {
      this.distance = document.documentElement.scrollTop || document.body.scrollTop
      let jump = this.$refs.bottomContent.getElementsByClassName('single-section')
      let total = jump[index].offsetTop // 获取需要滚动的距离
      this.total = total
      // Chrome
      document.body.scrollTop = this.total
      // Firefox
      document.documentElement.scrollTop = this.total
      // Safari
      window.pageYOffset = this.total
      this.currentFirstIndex = index
      this.step = this.total / 50
      if (this.total > this.distance) {
        this.smoothDown()
      } else {
        let newTotal = this.distance - this.total
        this.step = newTotal / 50
        this.smoothUp()
      }
    },
    _initScroll () {

    },
    scrool (pos) {
      let scrolled = document.documentElement.scrollTop || document.body.scrollTop
      for (var i = 0; i < this.listHeight.length; i++) {
        if (this.listHeight[i] < scrolled + 180 && scrolled + 180 < this.listHeight[i + 1]) {
          this.currentFirstIndex = i
          return false
        }
      }

      this.currentFirstIndex = this.listHeight.length - 1
    },
    smoothDown () {
      if (this.distance < this.total) {
        this.distance += this.step
        document.body.scrollTop = this.distance
        document.documentElement.scrollTop = this.distance
        setTimeout(this.smoothDown, 10)
      } else {
        document.body.scrollTop = this.total - 80
        document.documentElement.scrollTop = this.total - 80
      }
    },
    smoothUp () {
      if (this.distance > this.total) {
        this.distance -= this.step
        document.body.scrollTop = this.distance
        document.documentElement.scrollTop = this.distance
        setTimeout(this.smoothUp, 10)
      } else {
        document.body.scrollTop = this.total - 80
        document.documentElement.scrollTop = this.total - 80
      }
    },
    _calculateHeight () {
      let foodList = this.$refs.rightContent.getElementsByClassName('single-section')
      for (let i = 0; i < foodList.length; i++) {
        let item = foodList[i]
        this.listHeight.push(item.offsetTop)
      }
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 右边样式 -->
<style scoped>
  .center_column {
    min-height: 400px;
  }
  .img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
  }
</style>

<!-- products list -->
<style scoped>
  .product_list_wrapper {
    margin-left: -10px;
    margin-right: -10px;
  }

  .product_list_wrapper .product_list {
    position: relative;
  }

  ul.product_base_list {
    margin: 0;
  }

  .product-name, .product_reference, .functional-buttons > div a{
    color: #000;
  }
</style>

<!-- products list grid -->
<style scoped>
  ul.product_base_list li.base_product {
    padding: 0 10px;
    margin-bottom: 19px;
    margin-top: 3px;
  }

  ul.product_base_list:not(.product_sidebar) li.base_product:not(.sidebar_block_product) .product-container:hover {
    -moz-box-shadow: 0 10px 20px #c7c7c7;
    -webkit-box-shadow: 0 10px 20px #c7c7c7;
    box-shadow: 0 10px 20px #c7c7c7;
    -moz-transform: translate(0,-3px);
    -ms-transform: translate(0,-3px);
    -webkit-transform: translate(0,-3px);
    transform: translate(0,-3px);
  }

  ul.product_base_list li.base_product .product-container {
    z-index: 10;
    overflow: hidden;
    position: relative;
    background-color: #ffffff;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-box-shadow: 0 1px 5px #c7c7c7;
    -webkit-box-shadow: 0 1px 5px #c7c7c7;
    box-shadow: 0 1px 5px #c7c7c7;
    transition: all 0.3s;
  }

  ul.product_base_list .product-image-container {
    text-align: center;
    position: relative;
    overflow: hidden;
  }

  li a {
    color: inherit;
  }

  ul.product_base_list .product-image-container img {
    margin: 0 auto;
  }
  .img-responsive {
    display: block;
    max-width: 100%;
    height: auto;
  }
  a img {
    border: none;
  }

  ul.product_base_list .hover-box {
    visibility: hidden;
  }

  ul.product_base_list .hover-box > div {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    right: -20px;
    bottom: 0;
    overflow: hidden;
    max-width: 34px;
    transition: all 0.3s;
  }

  ul.product_base_list .hover-box > div + div {
    bottom: 36px;
    transition-delay: 0.1s;
  }

  ul.product_base_list .hover-box > div + div + div {
    bottom: 72px;
    transition-delay: 0.15s;
  }

  ul.product_base_list .hover-box > div:hover {
    max-width: 250px;
  }

  h1, h2, h3, h4, h5, h6 {
    /*font-family: "Roboto Condensed",sans-serif;*/
    font-weight: 700;
  }

  p {
    margin: 0 0 9px;
  }

  .btn-default {
    background-color: #fecd32!important;
    border-color: #fecd32!important;
  }

  .btn-default span{
    color: white;
    text-transform: uppercase;
  }
</style>

<!-- products list list -->
<style scoped>
  ul.product_base_list.list li.base_product {
    width: 100%;
  }

  ul.product_base_list.list li.base_product .product-container {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-flow: row wrap;
    flex-flow: row wrap;
  }

  /* left */
  ul.product_base_list.list li.base_product .product-container .left-block {
    width: 32%;
  }

  ul.product_base_list.list li.base_product .product-container .left-block .product-image-container {
    overflow: hidden;
  }

  ul.product_base_list.list li.base_product .product-container .left-block .product-image-container img {
    float: left;
  }

  /* right */
  ul.product_base_list.list li.base_product .product-container .right-block {
    width: 100%;
    padding: 15px 3% 83px;
    position: relative;
  }

  ul.product_base_list.list li.base_product .product-container .right-block h3 {
    padding-top: 7px;
    margin-right: 80px;
  }

  ul.product_base_list.list li.base_product .product-container .right-block .product-desc {
    margin-top: 10px;
  }

  ul.product_base_list .product-desc {
    margin-bottom: 10px;
    font-weight: 300;
  }

  ul.product_base_list.list li.base_product .product-container .right-block .absolute-bottom {
    position: absolute;
    left: 5%;
    right: 5%;
    bottom: 0;
    padding: 10px 0;
    overflow: hidden;
    border-top: 1px dashed #c7c7c7;
  }

  ul.product_base_list.list li.base_product .product-container .right-block .button-list {
    display: block;
    float: right;
    clear: left;
    line-height: 50px;
    margin-left: 1px;
  }

  .list .button-container.button-grid {
    display: none;
  }

  .btn-default{
    background: #fecd32;
  }

  ul.product_base_list.list li.base_product .product-container .right-block .functional-buttons {
    float: right;
  }

  ul.product_base_list .functional-buttons div a,
  ul.product_base_list .functional-buttons div label {
    font-weight: normal;
    cursor: pointer;
    line-height: 25px;
    font-size: 14px;
  }

  .functional-buttons a:hover {
    color: #fecd32;
  }

  ul.product_base_list.list li.base_product .product-container .right-block .product-desc {
    margin-top: 10px;
    margin-bottom: 10px;
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue